import type { BreakoutPluginOptions } from '@atlaskit/editor-plugin-breakout';

interface Props {
	options: Pick<BreakoutPluginOptions, 'allowBreakoutButton'>;
}

export function breakoutPluginOptions({ options }: Props): BreakoutPluginOptions {
	return {
		allowBreakoutButton: options.allowBreakoutButton,
	};
}
